import { motion } from "framer-motion";
import { HtmlContent } from "../../../../common/components";
import { SEVERITIES } from "../../../../common/constants";
import { Severity } from "../../../../common/types";

interface AnnouncementBannerProps {
    title: string;
    description: string;
    severity?: Severity;
    onClose: () => void;
}

const BANNER_SEVERITY_CONFIG = {
    [SEVERITIES.WARNING]: {
        bg: "bg-warning-default",
        icon: "pi pi-exclamation-triangle",
        iconColor: "text-warning-text",
        textColor: "text-warning-text",
        hoverColor: "hover:text-warning-text/70",
    },
    [SEVERITIES.INFO]: {
        bg: "bg-info-default",
        icon: "pi pi-info-circle",
        iconColor: "text-info-dark-50",
        textColor: "text-info-dark-50",
        hoverColor: "hover:text-info-dark-30",
    },
    [SEVERITIES.ERROR]: {
        bg: "bg-error-default",
        icon: "pi pi-exclamation-circle",
        iconColor: "text-error-dark-50",
        textColor: "text-error-dark-50",
        hoverColor: "hover:text-error-dark-30",
    },
    [SEVERITIES.SUCCESS]: {
        bg: "bg-success-default",
        icon: "pi pi-check-circle",
        iconColor: "text-success-dark-50",
        textColor: "text-success-dark-50",
        hoverColor: "hover:text-success-dark-30",
    },
};

const AnnouncementBanner = (props: AnnouncementBannerProps) => {
    const {
        title,
        description,
        severity = SEVERITIES.WARNING,
        onClose,
    } = props;

    const config =
        BANNER_SEVERITY_CONFIG[severity] ??
        BANNER_SEVERITY_CONFIG[SEVERITIES.INFO];

    return (
        <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="relative z-[30000] overflow-hidden"
        >
            <div className={`flex items-start px-4 py-3 ${config.bg}`}>
                <div className="flex flex-1 items-start justify-center gap-2">
                    <i
                        className={`${config.icon} ${config.iconColor} shrink-0 mt-1`}
                    />
                    <span className={`${config.textColor} flex`}>
                        <span className="font-bold">{title}</span>
                        {description && (
                            <HtmlContent
                                html={description}
                                className="ml-2"
                            />
                        )}
                    </span>
                </div>
                <button
                    className={`shrink-0 py-1 px-4 -mr-4 ${config.textColor} ${config.hoverColor} transition-colors`}
                    onClick={onClose}
                >
                    <i className="pi pi-times text-sm" />
                </button>
            </div>
        </motion.div>
    );
};

export default AnnouncementBanner;
